import { ZfBox } from '@zafire/react';
import type { FunctionComponent, PropsWithChildren } from 'react';

export const AdminContentBox: FunctionComponent<PropsWithChildren> = ({ children }) => (
    <ZfBox
        style={{
            flex: 1,
            maxHeight: 'calc(100vh - 120px - 2 * var(--padding-horizontal-lg)',
            margin: 'var(--padding-horizontal-lg)',
            padding: 'var(--padding-vertical-md) var(--padding-vertical-xl)',
            backgroundColor: 'var(--bg-color-default-normal)',
        }}
    >
        <ZfBox style={{ height: '100%', overflow: 'auto' }}>{children}</ZfBox>
    </ZfBox>
);
